import React from "react";
import { useTranslation } from "react-i18next";
import { LexicalEditor, LexicalCommand, createCommand } from "lexical";
import {
  Button,
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "@/components/ui";
import { BracesIcon } from "lucide-react";

export type TextTemplate = "student" | "sender";

export const INSERT_TEMPLATE_COMMAND: LexicalCommand<TextTemplate> =
  createCommand("INSERT_TEMPLATE_COMMAND");

export function AddNamePopover({ editor }: { editor: LexicalEditor }) {
  const { t } = useTranslation();

  return (
    <Popover>
      <PopoverTrigger asChild>
        <Button
          variant="ghost"
          size="sm"
          type="button"
          className="h-8 px-3 text-xs font-medium"
          aria-label={t("bulkMessaging.composeMessage.addName")}
        >
          <BracesIcon className="mr-1 h-4 w-4" />
          {t("bulkMessaging.composeMessage.addName")}
        </Button>
      </PopoverTrigger>
      <PopoverContent className="w-48 p-0" align="start">
        <div className="flex flex-col gap-1">
          <Button
            variant="ghost"
            size="sm"
            type="button"
            onClick={() => {
              editor.dispatchCommand(INSERT_TEMPLATE_COMMAND, "student");
            }}
            className="justify-start px-3 text-sm font-normal"
          >
            {t("bulkMessaging.composeMessage.addStudentName")}
          </Button>
          <Button
            variant="ghost"
            size="sm"
            type="button"
            onClick={() => {
              editor.dispatchCommand(INSERT_TEMPLATE_COMMAND, "sender");
            }}
            className="justify-start px-3 text-sm font-normal"
          >
            {t("bulkMessaging.composeMessage.addSenderName")}
          </Button>
        </div>
      </PopoverContent>
    </Popover>
  );
}
